import { cn } from '@/utils/cn'
import { LogoUploadField } from '@/components/Configuracao/LogoUploadField'
import type { AppearanceThemeProps } from '@/components/Configuracao/appearanceTypes'
export function AppearanceIdentidadeTab({ draft, updateDraft }: AppearanceThemeProps) {
  return (
    <div className="glass-card p-5 space-y-5">
      <h3 className="text-text-primary font-semibold text-sm">Identidade da Empresa</h3>

      <div className="flex flex-col gap-1.5">
        <label className="text-text-muted text-[11px] font-medium uppercase tracking-wider">Nome da Empresa</label>
        <input
          type="text"
          value={draft.companyName}
          onChange={(e) => updateDraft({ companyName: e.target.value })}
          placeholder="Ex: Rocket Search"
          className="bg-white/[0.04] border border-white/[0.06] text-text-primary rounded-md px-3 py-2 text-xs outline-none focus:border-accent transition-colors"
        />
      </div>

      <div className="grid grid-cols-1 gap-6">
        <LogoUploadField
          variant="dark"
          label="Logo (Tema Escuro)"
          value={draft.logoUrlDark || draft.logoUrl}
          previewClassName="bg-bg-dark"
          companyInitial={draft.companyName.charAt(0) || 'R'}
          onChange={(logoUrlDark) => updateDraft({ logoUrlDark })}
        />
        <LogoUploadField
          variant="light"
          label="Logo (Tema Claro)"
          value={draft.logoUrlLight || draft.logoUrl}
          previewClassName="bg-white"
          companyInitial={draft.companyName.charAt(0) || 'R'}
          onChange={(logoUrlLight) => updateDraft({ logoUrlLight })}
        />
        <LogoUploadField
          variant="fallback"
          label="Logo Genérica (Fallback)"
          value={draft.logoUrl}
          previewClassName="bg-bg-card"
          companyInitial={draft.companyName.charAt(0) || 'R'}
          onChange={(logoUrl) => updateDraft({ logoUrl })}
          helperText="Usada quando não há logo específica para o modo escuro ou claro."
        />
      </div>

      {/* Dark/Light mode */}
      <div className="flex flex-col gap-1.5">
        <label className="text-text-muted text-[11px] font-medium uppercase tracking-wider">Modo de Exibição</label>
        <div className="flex gap-2">
          {(['dark', 'light'] as const).map((mode) => (
            <button
              key={mode}
              onClick={() => updateDraft({ mode })}
              className={cn(
                'flex items-center gap-2 px-4 py-2.5 rounded-lg border transition-all min-h-[44px]',
                draft.mode === mode
                  ? 'border-accent bg-accent/10 text-accent'
                  : 'border-white/[0.06] bg-white/[0.04] text-text-muted hover:text-text-primary'
              )}
            >
              <span className="text-[13px] font-medium capitalize">{mode === 'dark' ? 'Escuro' : 'Claro'}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
